<ngx-loading [show]="loading" [config]="{ backdropBackgroundColour: 'rgba(0,0,0,0.6)' }" #customLoadingTemplate></ngx-loading>
<p *ngIf="!orderTrackings && !loading"><em>Sem dados</em></p>

<!-- Filter -->
<div *ngIf="orderTrackings" class="containerSearchTxtOrder" style="margin-bottom: 7px; margin-top: -9px;">
  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important;" [disabled]="loading" (click)="refrehPage()">
    <img title="Atualizar" style="cursor: pointer; cursor: pointer; height: 24px; width: 24px; cursor: inherit; margin-right: 15px;" src="/update.svg" />
  </button>

  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important;" [disabled]="loading">
    <img title="Buscar" style="height: 24px; width: 24px; cursor: inherit; margin-right: 5px;" src="/search.svg" />
  </button>

  <!--Selecione uma região-->
  <div class="col-lg-2 filter-combo">
    <mat-form-field class="select-form">
      <mat-select placeholder="Selecione o status dos pedidos"
                  name="regionField"
                  class="filter-select"
                  [(ngModel)]="filterOrderStatesSelected"
                  multiple
                  #orderStatusSelect="ngModel"
                  (openedChange)="applyFilter($event)">
        <div class="regionsSelectAll" (click)="selectAll(orderStatusSelect, orderStatusFiltered)">marcar/desmarcar todos</div>
        <mat-option *ngFor="let orderState of orderStatusFiltered" [value]="orderState.id" (click)="regionChecked()">
          {{orderState.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <input type="text" (ngxInputSearch)="doSearch($event)"
         (emptyInput)="doSearchClear()"
         stringLength="0" class="searchTxt" placeholder="OV/PEDIDO" /> <!--Removido estas informações devido a complexidade em aplicar o filtro NOME/CPF/CNPJ/-->
</div>

<!-- Grid tracking -->
<table class='table table-striped' aria-labelledby="tableLabel" align="center" *ngIf="orderTrackings">
  <thead>
    <tr>

      <th *ngIf="registerLimite" style="border: none !important; " colspan="5">Você esta visualizando todos registros.
        <button mat-button class="fgl-mat-button reprocessar-text" (click)="registerLimiteChange()">
          <span>Restringir dados para os ultimos 30 dias.</span>
        </button></th>
      <th *ngIf="!registerLimite" style="border: none !important; color: red !important; background-color: beige" colspan="5">Você esta visualizando registros dos ultimos 30 dias.
        <button mat-button class="fgl-mat-button reprocessar-text" (click)="registerLimiteChange()">
          <span>Ver todos os regsitros.</span>
        </button></th>
      <th style="text-align:center;" colspan="6">STATUS DO PEDIDO</th>
      <!--<th style="border: none !important" *ngIf="currentUser.userPermission.orderService.write"> </th>-->
    </tr>

    <tr height="50">
      <th style="text-align:center; white-space: pre-line !important; width: 80px !important">Tempo percorrido</th>
      <th style="text-align:center; width: 125px !important">Data/Hora</th>
      <th style="text-align:center;">Nome</th>
      <th style="text-align:center;">CPF/CNPJ</th>
      <th style="text-align:center;">Valor</th>

      <th style="text-align:center; width: 130px; white-space: normal;">Pedido incluído no APP</th>
      <th style="text-align:center; width: 130px; white-space: normal;">Aprovação do pedido</th>
      <th style="text-align:center; width: 130px; white-space: normal;">Pedido baixado</th>
      <th style="text-align:center; width: 130px; white-space: normal;">Pedido faturado</th>
      <th style="text-align:center; width: 130px; white-space: normal;">Expedição</th>
      <th style="text-align:center; width: 130px; white-space: normal;">Entrega</th>
      <th style="text-align:center; width: 130px; white-space: normal;" *ngIf="currentUser.userPermission.orderService.write">Alterar pedido</th>
    </tr>

  </thead>
  <tbody>
    <tr *ngFor="let orderTrackingItem of orderTrackings | paginate: { id: 'OrderTracking', itemsPerPage: pageSize, currentPage: p, totalItems: total }; let i = index" class="table-row-size">
      <td style="text-align:center;" title="{{ orderTrackingItem.orderLifeTimeFormated }}">{{ orderTrackingItem.orderLifeTimeFormated }}</td>
      <td style="text-align:center;" title="{{ orderTrackingItem.creationDateFormated }}">{{ orderTrackingItem.creationDateFormated }}</td>
      <td style="white-space: inherit !important;" title="{{ orderTrackingItem.customer.nome }}">{{ orderTrackingItem.customer.nome }}</td>
      <td style="text-align:center;" title="{{ orderTrackingItem.customer.cpfCnpj }}">{{ orderTrackingItem.customer.cpfCnpj }}</td>
      <td style="text-align:center;" title="{{ orderTrackingItem.totalValueFormated }}">{{ orderTrackingItem.totalValueFormated }}</td>

      <!--Pedido incluído no APP-->
      <td style="text-align:center;">
        <div *ngIf="orderTrackingItem.orderReceived.isSuccess">
          <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderReceived', i, $event)" class="order" style="cursor: pointer;" src="/order_incluido.svg" />
          <div *ngIf="orderTrackingItem.orderNumber.indexOf('APPF_') >= 0">{{orderTrackingItem.orderNumber}}</div>
          <div *ngIf="orderTrackingItem.orderNumber.indexOf('APPF_') == -1">{{orderTrackingItem.agroup}}</div>
        </div>
      </td>

      <!--Aprovação do pagamento-->
      <td style="text-align:center;">
        <div *ngIf="orderTrackingItem.orderPayment.isSuccess">
          <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderPayment', i, $event)" class="order" style="cursor: pointer;" src="/{{orderTrackingItem.orderPayment.iconPayment}}" />
          <div *ngFor="let paymentProvidersItem of orderTrackingItem.orderPayment.paymentProviders; let i = index">
            {{paymentProvidersItem.genericName}} <img class="details-aprovacao" style="cursor: inherit; " src="/{{paymentProvidersItem.iconStatus}}" />
            <br>
          </div>
        </div>

        <div *ngIf="orderTrackingItem.orderPayment.isError">
          <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderPayment', i, $event)" class="order" style="cursor: pointer;" src="/canceled.svg" />
          <div>Erro</div>
        </div>
      </td>

      <!--Pedido integrado-->
      <td style="text-align:center;">
        <div *ngIf="orderTrackingItem.orderIntegrated.isSuccess">
          <img class="order" style="cursor: inherit;" src="/order_pedidoBaixado.svg" />
          <div>{{ orderTrackingItem.salesId }}</div>
        </div>

        <div *ngIf="orderTrackingItem.orderIntegrated.isError" (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderIntegrated', i, $event)"  style="cursor: pointer;">
          <div *ngIf="orderTrackingItem.salesId != ''">
            <img class="order" style="cursor: inherit;" src="/order_pedidoBaixado.svg" />
            <div>{{ orderTrackingItem.salesId }}</div>
            <div>com erro(s) <img style="height: 15px; width: 15px;" src="/canceled.svg" /></div>
          </div>
          <div *ngIf="orderTrackingItem.salesId == ''">
            <img class="order" src="/canceled.svg" />
            <div>Erro</div>
          </div>
        </div>
      </td>

      <!--Pedido faturado-->
      <td style="text-align:center;">
        <div *ngIf="orderTrackingItem.orderInvoiced.isSuccess">
          <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderInvoiced', i, $event)" class="order" style="cursor: pointer;" src="/order_pedidoFaturado.svg" />
          <div>{{ orderTrackingItem.numberNF }}</div>
          <div *ngIf="!orderTrackingItem.orderInvoiced.isSameItemsOrderReceived">
            <img class="details" style="cursor: inherit;" src="/order_antiAlerta.svg" />
          </div>
        </div>

        <div *ngIf="orderTrackingItem.orderInvoiced.isError">
          <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderInvoiced', i, $event)" class="order" style="cursor: pointer;" src="/canceled.svg" />
          <div>Erro</div>
        </div>
      </td>

      <!--Expedição-->
      <td style="text-align:center;">
        <div *ngIf="orderTrackingItem.orderTrafficking.isSuccess">
          <div *ngIf="orderTrackingItem.deliveryMethod.type === 'pickup'">
            <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderTrafficking', i, $event)" class="order" style="cursor: pointer;" src="/order_pedidoExpedidoLoja2.svg" />
            <div>Retirar na Loja {{orderTrackingItem.deliveryMethod.deliveryLocation.branchId}}</div>
          </div>
          <div *ngIf="orderTrackingItem.deliveryMethod.type === 'express'">
            <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderTrafficking', i, $event)" class="order" style="cursor: pointer;" src="/order_pedidoExpedido.svg" />
            <div>Pedido em trânsito</div>
          </div>
          <div *ngIf="orderTrackingItem.deliveryMethod.type === 'normal'">
            <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderTrafficking', i, $event)" class="order" style="cursor: pointer;" src="/order_pedidoExpedido.svg" />
            <div>Pedido em trânsito</div>
          </div>
        </div>

        <div *ngIf="orderTrackingItem.orderTrafficking.isError">
          <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderTrafficking', i, $event)" class="order" style="cursor: pointer;" src="/canceled.svg" />
          <div>Erro</div>
        </div>
      </td>

      <!--Entrega-->
      <td style="text-align:center;">
        <div *ngIf="orderTrackingItem.orderDelivered.isSuccess">
          <img class="order" style="cursor: inherit;" src="/order_pedidoEntregue.svg" />
          <div>Pedido entregue</div>
          <div>{{orderTrackingItem.orderDelivered.deliveryDateFormated}}</div>
        </div>
      </td>

      <!--Reprocessar-->
      <td style="text-align:center;" *ngIf="currentUser.userPermission.orderService.write">
      <button mat-button class="fgl-mat-button reprocessar-text" (click)="modalReprocess('modalReprocessOrdemItemTrackingCard', orderTrackingItem)">
        <mat-icon class="reprocessar-icon"></mat-icon>
        <span>Reprocessar</span>
      </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="12">
        <pagination-controls id="OrderTracking"
                             (pageChange)="pageChanged($event)"
                             (pageBoundsCorrection)="pageChanged($event)"
                             maxSize="9"
                             directionLinks="true"
                             autoHide="true"
                             responsive="true"
                             previousLabel="anterior"
                             nextLabel="próximo"
                             screenReaderPaginationLabel="Paginação"
                             screenReaderPageLabel="pagina"
                             screenReaderCurrentLabel="você esta na página">
        </pagination-controls>
      </td>
    </tr>
  </tfoot>
</table>

<div class="container">
  <!--Details Modal-->
  <div class="modal modal-tracking ui-widget-content" id="modalDetailOrdemItemTrackingCard" role="dialog" style="height:auto;">
    <div class="modal-dialog modal-dialog-tracking" style="width: 410px;">

      <div class="modal-content modal-content-tracking" style="height:400px">

        <!--Modal Header-->
        <div class="modal-header-tracking">

          <!--Pedido incluído no APP-->
          <div *ngIf="orderTrackingType === 'orderReceived'">
            <img class="order" src="/order_incluido.svg" />
            <div *ngIf="this.orderTracking.orderNumber.indexOf('APPF_') >= 0">{{this.orderTracking.orderNumber}}</div>
            <div *ngIf="this.orderTracking.orderNumber.indexOf('APPF_') == -1">{{this.orderTracking.agroup}}</div>

          </div>

          <!--Aprovação do pagamento-->
          <div *ngIf="orderTrackingType === 'orderPayment'">
            <div *ngIf="orderTracking.orderPayment.isSuccess">
              <img class="order" src="/order_pagamentoAprovado.svg" />
              <div>Pagamento</div>
            </div>
            <div *ngIf="orderTracking.orderPayment.isError">
              <img class="order" src="/canceled.svg" />
              <div>Pagamento</div>
            </div>
          </div>

          <!--Pedido integrado-->
          <div *ngIf="orderTrackingType === 'orderIntegrated'">
            <div *ngIf="orderTracking.orderIntegrated.isError">
              <img class="order" src="/canceled.svg" />
              <div>Erro</div>
            </div>
          </div>

          <!--Pedido faturado-->
          <div *ngIf="orderTrackingType === 'orderInvoiced'">
            <div *ngIf="orderTracking.orderInvoiced.isSuccess">
              <img class="order" src="/order_pedidoFaturado.svg" />
              <div>{{ this.orderTracking.numberNF }}</div>
            </div>
            <div *ngIf="orderTracking.orderInvoiced.isError">
              <img class="order" src="/canceled.svg" />
              <div>Erro</div>
            </div>
          </div>

          <!--Expedição-->
          <div *ngIf="orderTrackingType === 'orderTrafficking'">
            <div *ngIf="orderTracking.orderTrafficking.isSuccess">
              <div *ngIf="orderTracking.deliveryMethod.type === 'pickup'">
                <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderTrafficking', i, $event)" class="order" src="/order_pedidoExpedidoLoja2.svg" />
                <div>{{orderTracking.deliveryMethodFormated}}</div>
                <div>Loja {{orderTracking.deliveryMethod.deliveryLocation.branchId}}</div>
              </div>
              <div *ngIf="orderTracking.deliveryMethod.type === 'express'">
                <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderTrafficking', i, $event)" class="order" src="/order_pedidoExpedido.svg" />
                <div>{{orderTracking.deliveryMethodFormated}}</div>
                <div>Loja {{orderTracking.deliveryMethod.deliveryLocation.branchId}}</div>
              </div>
              <div *ngIf="orderTracking.deliveryMethod.type === 'normal'">
                <img (click)="openModal('modalDetailOrdemItemTrackingCard', 'orderTrafficking', i, $event)" class="order" src="/order_pedidoExpedido.svg" />
                <div>{{orderTracking.deliveryMethodFormated}}</div>
                <div>Loja {{orderTracking.deliveryMethod.deliveryLocation.branchId}}</div>
              </div>
            </div>
          </div>

        </div>

        <!--Modal Body-->
        <div class="modal-body modal-body-tracking" style="max-height: calc(100vh - 366px); overflow-y: auto;">

          <!--Pedido incluído no APP-->
          <div *ngIf="orderTrackingType === 'orderReceived'">
            <div *ngFor="let orderItemsReceived of this.orderTracking.orderReceived.orderItemsViewModel; let i = index">
              <div style="font-size: 13px;">- ({{orderItemsReceived.erpCode}}) {{orderItemsReceived.productName}}</div>
              <div style="font-size: 13px; font-weight: 500; margin-bottom: 10px;">R$ {{orderItemsReceived.unitPrice}} x {{orderItemsReceived.quantity}}</div>
            </div>
            <hr class="modal-hr" />
            <div>{{this.orderTracking.deliveryMethodFormated}}</div>
            <div>Loja {{this.orderTracking.deliveryMethod.deliveryLocation.branchId}}</div>

            <div *ngIf="orderTracking.deliveryMethod.type === 'express' || orderTracking.deliveryMethod.type === 'normal'">Data prevista de entregue: {{orderTracking.deliveryMethod.deliveryOption.dateEstimated | date:'dd/MM/yyyy HH:mm' }}</div>
            <div *ngIf="orderTracking.deliveryMethod.type === 'express' || orderTracking.deliveryMethod.type === 'normal'">Tipo de entregue: {{orderTracking.deliveryMethod.type}}</div>

          </div>

          <!--Aprovação do pagamento-->
          <div *ngIf="orderTrackingType === 'orderPayment'">
            <div *ngIf="orderTracking.orderPayment.isSuccess">
              <div *ngFor="let orderItemsPaymentProvider of this.orderTracking.orderPayment.paymentProviders; let i = index">
                <div style="font-size: 13px;">{{orderItemsPaymentProvider.genericName}} ({{orderItemsPaymentProvider.providerName}})</div>
                <div style="font-size: 13px;">{{orderItemsPaymentProvider.descriptionStatus}}</div>

                <br><br>
              </div>
            </div>
            <div *ngIf="orderTracking.orderPayment.isError">
              <div innerHTML="{{this.orderTracking.orderPayment.msgError}}"></div>
            </div>
          </div>

          <!--Pedido integrado-->
          <div *ngIf="orderTrackingType === 'orderIntegrated'">
            <div *ngIf="orderTracking.orderIntegrated.isError">
              <div innerHTML="{{this.orderTracking.orderIntegrated.msgError}}"></div>
            </div>
          </div>

          <!--Pedido faturado-->
          <div *ngIf="orderTrackingType === 'orderInvoiced'">
            <div *ngIf="orderTracking.orderInvoiced.isSuccess">
              <div *ngIf="!orderTracking.orderInvoiced.isSameItemsOrderReceived">
                <div style="font-weight: 500;"><img class="details" style="cursor: inherit;" src="/order_antiAlerta.svg" /> ATENÇÃO: Existem divergências entre o pedido realizado no APPF e o pedido faturado no ERP</div>
                <br>
              </div>
              <div *ngFor="let orderItemsInvoiced of this.orderTracking.orderInvoiced.orderItemsViewModel; let i = index">
                <div style="font-size: 13px;">- ({{orderItemsInvoiced.erpCode}}) {{orderItemsInvoiced.productName}}</div>
                <div style="font-size: 13px; font-weight: 500; margin-bottom: 10px;">R$ {{orderItemsInvoiced.unitPrice}} x {{orderItemsInvoiced.quantity}}</div>
              </div>
            </div>
            <div *ngIf="orderTracking.orderInvoiced.isError">
              <div innerHTML="{{this.orderTracking.orderInvoiced.msgError}}"></div>
            </div>
            <br>
          </div>

          <!--Expedição-->
          <div *ngIf="orderTrackingType === 'orderTrafficking'">
            <div *ngIf="orderTracking.orderTrafficking.isSuccess">
              <div *ngIf="orderTracking.deliveryMethod.type === 'pickup'">
                <div style="font-size: 13px;"> Endereço da loja: {{orderTracking.deliveryMethod.deliveryLocation.fullAddress}}</div>
                <br>
                <div style="font-size: 13px;"> Responsável pela retirada: {{orderTracking.customer.nome}}</div>
                <div style="font-size: 13px;"> CPF/CNPJ: {{orderTracking.customer.cpfCnpj}}</div>
              </div>
              <div *ngIf="orderTracking.deliveryMethod.type === 'express'">
                <div> Entregue por: {{orderTracking.deliveryProvider}}</div>
                <br>
                <div> Endereço da loja: {{orderTracking.deliveryMethod.deliveryLocation.fullAddress}}</div>
                <br>
                <div>
                  Endereço do cliente:  <div class="fgl-captalize">
                    {{orderTracking.deliveryMethod.deliveryAddress.address.toLocaleLowerCase()}},
                    {{orderTracking.deliveryMethod.deliveryAddress.number.toLocaleLowerCase()}},
                    {{orderTracking.deliveryMethod.deliveryAddress.district.toLocaleLowerCase()}},
                    {{orderTracking.deliveryMethod.deliveryAddress.zipCode.toLocaleLowerCase()}},
                    {{orderTracking.deliveryMethod.deliveryAddress.city.toLocaleLowerCase()}}
                  </div>
                </div>
                <br>
                <div> Data prevista de entregue: {{orderTracking.deliveryMethod.deliveryOption.dateEstimated | date:'dd/MM/yyyy HH:mm' }}</div>
              </div>
              <div *ngIf="orderTracking.deliveryMethod.type === 'normal'">
                <div> Entregue por: {{orderTracking.deliveryProvider}}</div>
                <br>
                <div> Endereço da loja: {{orderTracking.deliveryMethod.deliveryLocation.fullAddress}}</div>
                <br>
                <div>
                  Endereço do cliente: <div class="fgl-captalize"> 
                    {{orderTracking.deliveryMethod.deliveryAddress.address.toLocaleLowerCase()}},
                    {{orderTracking.deliveryMethod.deliveryAddress.number.toLocaleLowerCase()}},
                    {{orderTracking.deliveryMethod.deliveryAddress.district.toLocaleLowerCase()}},
                    {{orderTracking.deliveryMethod.deliveryAddress.zipCode.toLocaleLowerCase()}},
                    {{orderTracking.deliveryMethod.deliveryAddress.city.toLocaleLowerCase()}}
                  </div>
                </div>
                <br>
                <div> Data prevista de entregue: {{orderTracking.deliveryMethod.deliveryOption.dateEstimated | date:'dd/MM/yyyy HH:mm' }}</div>
              </div>
            </div>
            <div *ngIf="orderTracking.orderTrafficking.isError">
              <img class="order" style="cursor: pointer;" src="/canceled.svg" />
              <div>Erro</div>
              <br>
              <div innerHTML="{{this.orderTracking.orderTrafficking.msgError}}"></div>
            </div>
          </div>
          <div class="modal-footer modal-footer-tracking">
            <button class="btn btn-outline" [disabled]="loading" (click)="closeModal('modalDetailOrdemItemTrackingCard')">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>

<!--Details Modal reprocess-->
<div class="modal" id="modalReprocessOrdemItemTrackingCard" role="dialog">
  <div class="modal-dialog modal-dialog-reprocess">
    <div class="modal-content">
      <div class="modal-header">
        <h3>Confirmação para reprocessamento</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalReprocessOrdemItemTrackingCard')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        <p>Ao confirmar esta ação, você reiniciará o processo do pedido apartir da confirmação do usuário no aplicativo.</p>
        <p>Você confirma?</p>
        <mat-radio-group [(ngModel)]="processingConfirmation" aria-label="Select an option">

          <mat-radio-button value="1">Sim</mat-radio-button>
          <mat-radio-button value="2">Não</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="modal-footer">
        <div *ngIf="processingConfirmation === '1'">
          <button class="btn btn-outline" [disabled]="loading" (click)="reprocessOrdemItemModalReprocess()">Reprocessar</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Message Modal-->
<div class="modal" id="modalMessage" role="dialog">
  <div class="modal-dialog modal-dialog-reprocess">
    <div class="modal-content">
      <div class="modal-header">
        <h3>{{modalMessageTitle}}</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalMessage')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        <p class="modalMessage-text" innerHTML="{{modalMessageText}}"></p>
      </div>
    </div>
  </div>
</div>
</div>
